module.exports = __webpack_public_path__ + "img/artist-mikeparsons.a96433b7.jpg";